import { render, staticRenderFns } from "./poster-v2-edit.vue?vue&type=template&id=4d1f1dc3&scoped=true"
import script from "./poster-v2-edit.vue?vue&type=script&lang=js"
export * from "./poster-v2-edit.vue?vue&type=script&lang=js"
import style0 from "./poster-v2-edit.vue?vue&type=style&index=0&id=4d1f1dc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1f1dc3",
  null
  
)

export default component.exports